import { render } from "./ClientSelector.vue?vue&type=template&id=5c848315&scoped=true"
import script from "./ClientSelector.vue?vue&type=script&lang=js"
export * from "./ClientSelector.vue?vue&type=script&lang=js"

import "./ClientSelector.vue?vue&type=style&index=0&id=5c848315&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c848315"]])

export default __exports__